// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","962":"home"}[chunkId] + "." + {"594":"e3834f69","962":"bad7b941"}[chunkId] + ".js";
};